import React from "react";

import { MemberProfileActivityEntry } from "../../../component-library";

const BillingChange = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { admin_id, admin_name, automatic_payment_enabled } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Dark"
      iconAlt="BillingChangeIcon"
      iconSrc="activate_timeline.svg"
      localDateTime={localCreatedTime}
      subTitle={`Automatic charging ${automatic_payment_enabled ? "enabled" : "disabled"}.`}
      title="Billing Change"
    >
      <div className="fs-14">{`Updated By: ${admin_name} (${admin_id})`}</div>
    </MemberProfileActivityEntry>
  );
};

export default BillingChange;
